import React, { useState } from 'react';

function BanModal({ user, onConfirm, onClose }) {
  const [selectedReason, setSelectedReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [duration, setDuration] = useState('permanent');
  const [loading, setLoading] = useState(false);

  const predefinedReasons = [
    'Spam fəaliyyəti',
    'Fake account',
    'Sui-istifadə',
    'Qaydaların pozulması',
    'Digər',
  ];

  const handleConfirm = async () => {
    const reason =
      selectedReason === 'Digər' ? customReason : selectedReason;

    if (!reason) {
      alert('Səbəb seçin və ya yazın!');
      return;
    }

    setLoading(true);
    await onConfirm(user.id, reason, duration);
    setLoading(false);
  };

  return (
    <>
      <div style={styles.overlay} onClick={onClose}></div>
      <div style={styles.modal}>
        <div style={styles.modalHeader}>
          <h3 style={styles.modalTitle}>🚫 User Ban Et</h3>
        </div>

        <div style={styles.modalBody}>
          <div style={styles.userInfo}>
            <img
src={user.avatar_url || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.full_name || 'User')}&background=FF6B35&color=fff&size=60`}
              alt={user.full_name}
              style={styles.avatar}
            />
            <div>
              <p style={styles.userName}>{user.full_name}</p>
              <p style={styles.userUsername}>@{user.username}</p>
            </div>
          </div>

          {/* Səbəb */}
          <div style={styles.section}>
            <label style={styles.label}>Səbəb:</label>
            {predefinedReasons.map((reason) => (
              <label key={reason} style={styles.radioLabel}>
                <input
                  type="radio"
                  name="reason"
                  value={reason}
                  checked={selectedReason === reason}
                  onChange={(e) => setSelectedReason(e.target.value)}
                  style={styles.radio}
                />
                {reason}
              </label>
            ))}

            {selectedReason === 'Digər' && (
              <textarea
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
                placeholder="Səbəbi yazın..."
                style={styles.textarea}
                rows={3}
              />
            )}
          </div>

          {/* Müddət */}
          <div style={styles.section}>
            <label style={styles.label}>Ban müddəti:</label>
            <label style={styles.radioLabel}>
              <input
                type="radio"
                name="duration"
                value="7days"
                checked={duration === '7days'}
                onChange={(e) => setDuration(e.target.value)}
                style={styles.radio}
              />
              7 gün
            </label>
            <label style={styles.radioLabel}>
              <input
                type="radio"
                name="duration"
                value="30days"
                checked={duration === '30days'}
                onChange={(e) => setDuration(e.target.value)}
                style={styles.radio}
              />
              30 gün
            </label>
            <label style={styles.radioLabel}>
              <input
                type="radio"
                name="duration"
                value="permanent"
                checked={duration === 'permanent'}
                onChange={(e) => setDuration(e.target.value)}
                style={styles.radio}
              />
              Daimi
            </label>
          </div>
        </div>

        <div style={styles.modalFooter}>
          <button onClick={onClose} style={styles.btnCancel} disabled={loading}>
            Ləğv Et
          </button>
          <button onClick={handleConfirm} style={styles.btnConfirm} disabled={loading}>
            {loading ? 'Ban edilir...' : 'Ban Et'}
          </button>
        </div>
      </div>
    </>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: 1000,
  },
  modal: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    borderRadius: '16px',
    width: '90%',
    maxWidth: '500px',
    maxHeight: '90vh',
    overflowY: 'auto',
    zIndex: 1001,
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
  },
  modalHeader: {
    padding: '25px',
    borderBottom: '2px solid #F0F0F0',
    textAlign: 'center',
  },
  modalTitle: {
    fontSize: '22px',
    fontWeight: 'bold',
    color: '#F44336',
    margin: 0,
  },
  modalBody: {
    padding: '25px',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    marginBottom: '25px',
    padding: '15px',
    backgroundColor: '#F8F9FA',
    borderRadius: '12px',
  },
  avatar: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    objectFit: 'cover',
  },
  userName: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    marginBottom: '3px',
  },
  userUsername: {
    fontSize: '14px',
    color: '#999',
  },
  section: {
    marginBottom: '25px',
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#1A1A2E',
    marginBottom: '12px',
  },
  radioLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px',
    marginBottom: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#1A1A2E',
    borderRadius: '8px',
    transition: 'background-color 0.2s',
  },
  radio: {
    cursor: 'pointer',
    width: '18px',
    height: '18px',
  },
  textarea: {
    width: '100%',
    padding: '12px',
    fontSize: '14px',
    border: '2px solid #E0E0E0',
    borderRadius: '8px',
    outline: 'none',
    resize: 'vertical',
    fontFamily: 'inherit',
    marginTop: '10px',
  },
  modalFooter: {
    padding: '20px 25px',
    borderTop: '2px solid #F0F0F0',
    display: 'flex',
    gap: '15px',
    justifyContent: 'flex-end',
  },
  btnCancel: {
    padding: '12px 24px',
    backgroundColor: '#E0E0E0',
    color: '#1A1A2E',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
  btnConfirm: {
    padding: '12px 24px',
    backgroundColor: '#F44336',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
};

export default BanModal;